import Immutable from 'immutable';

import { WIZARD_FIRST_STEP } from "constants";
import {
    TRANSFER_ACCOUNT_FROM_ANOTHER_BANK_SET_VALIDATE,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_RESET,
    TRANSFER_ACCOUNT_FROM_ANOTHER_BANK_VALIDATE,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_SET_IBAN,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_SET_APPLICATION_DATE,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_SET_APPLICATION_DATE_INVALID,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_ENTITY_NAME_REQUEST,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_ENTITY_NAME_SUCCESS,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_ENTITY_NAME_FAILURE,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_UPDATE_CHECKBOX,
    TRANSFER_ACCOUNT_SEND_REQUEST,
    TRANSFER_ACCOUNT_SEND_SUCCESS,
    TRANSFER_ACCOUNT_SEND_FAILURE,
    TRANSFER_ACCOUNT_DOWNLOAD_DOCUMENT_FAILURE,
    TRANSFER_ACCOUNT_DOWNLOAD_DOCUMENT_REQUEST,
    TRANSFER_ACCOUNT_DOWNLOAD_DOCUMENT_SUCCESS,
} from "constants/actionTypes";

import { STATUSES } from "routes/bringAccount/constants/bringAccountConstants";
import { DEFAULT_DATE } from 'routes/bringAccount/constants/bringAccountConstants';
import { validateByStep } from 'routes/bringAccount/helpers/bringAccountHelper';
import { AUTHORISE_REQUEST, AUTHORISE_STEPS } from 'routes/bringAccount/constants/bringAccountConstants';
import { validateIbanFormatOpenbankCountries } from '../utilities/ibanHelper';

const INITIAL_STATE = Immutable.fromJS({
    status: STATUSES.IDLE,
    error: '',
    currentStep: WIZARD_FIRST_STEP,
    iban: {
        number: '',
        isDirty: false,
        isValid: false,
        exists: false,
    },
    entity: {
        status: STATUSES.IDLE,
        bank_name: null,
        error: null,
    },
    [AUTHORISE_REQUEST]:{
       validationCheck1: false,
       validationCheck2: false,
       validationCheck3: false,
       validationCheck4: false,
    },
    [AUTHORISE_STEPS]:{
       validationCheck5: false,
       validationCheck6: false,
       validationCheck7: false,
    },
    executionDate: DEFAULT_DATE,
    executionDateIsVald: true,
    documentId: null,
    downloadDocumentStatus: STATUSES.IDLE,
    steps: [
        { valid: true, },
        { valid: true, },
        { valid: true, },
        { valid: true },
    ],
});


const setVisibleStep = (previousState, step) => {
    return previousState.merge({
        currentStep: step,
    })
}

const validateFlow = (previousState) => {
    const currentStep = previousState.get('currentStep');
    const isValidFlow = validateByStep(previousState, { currentStep });

    return isValidFlow
        ? previousState.merge({
            currentStep: previousState.get('currentStep') + 1,
        })
        : previousState
}

const setResetState = (previousState) => {
    return previousState.merge(INITIAL_STATE);
}

const setIban = (previousState, { ibanNumber, isValidIbanNumber }) => {
    const isValidFormat = validateIbanFormatOpenbankCountries(ibanNumber)

    return previousState.merge({
        iban: {
            number: ibanNumber,
            isDirty: true,
            isValid: isValidFormat,
            exists: isValidIbanNumber
        },
        entity: {
            status: STATUSES.IDLE,
            bank_name: '',
            error: '',
        },
    });
}

const setExecutionDate = (previousState, executionDate, isValid = true) => {
    return previousState.merge({
        executionDate,
        executionDateIsVald: isValid,
    })
}

const setEntityName = (previousState, { name, status, error = null }) => {
    return previousState.merge({
        entity: {
            status,
            bank_name: name,
            error,
        }
    });
}

const updateAuthoriseCheckbox = (previousState, { checkboxGroup, name, isChecked }) => {
    const previewCheckboxGroup = previousState.get(checkboxGroup).toJS();
    return previousState.merge({
        [checkboxGroup]: {
            ...previewCheckboxGroup,
            [name]: isChecked,
        }
    });
}

const setTransferRequest = (previousState, { status, documentId = null, error = null }) => {
    return previousState.merge({
        status,
        documentId,
        error,
    });
}

const setDownloadTransferDocument = (previousState, { status }) => {
    return previousState.merge({
        downloadDocumentStatus: status,
    });
}

function bringAccount(state = INITIAL_STATE, action) {
    switch (action.type) {
        case TRANSFER_ACCOUNT_FROM_ANOTHER_BANK_SET_VALIDATE:
            return setVisibleStep(state, action.payload.step);

        case TRANSFER_ACCOUNT_FROM_ANOTHER_BANK_VALIDATE:
            return validateFlow(state);

        case TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_RESET:
            return setResetState(state);

        case TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_SET_IBAN:
            return setIban(state, action.payload);

        case TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_SET_APPLICATION_DATE:
            return setExecutionDate(state, action.payload.executionDate, true);

        case TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_SET_APPLICATION_DATE_INVALID:
            return setExecutionDate(state, state.executionDate, false);

        case TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_UPDATE_CHECKBOX:
            return updateAuthoriseCheckbox(state, action.payload);

        case TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_ENTITY_NAME_REQUEST:
            return setEntityName(state, {
                status: STATUSES.FETCHING,
                name: null,
            });
    
        case TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_ENTITY_NAME_SUCCESS:
            return setEntityName(state, {
                name: action.payload.response.bankName,
                status: STATUSES.FETCHED
            });

        case TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_ENTITY_NAME_FAILURE:
            return setEntityName(state, {
                name: null,
                status: STATUSES.ERROR,
                error: STATUSES.ERROR,
            });

        case TRANSFER_ACCOUNT_SEND_REQUEST:
            return setTransferRequest(state, { status: STATUSES.SAVING });

        case TRANSFER_ACCOUNT_SEND_SUCCESS:
            return setTransferRequest(state, {
                status: STATUSES.SAVED,
                documentId: action.payload.response.documentId
            });

        case TRANSFER_ACCOUNT_SEND_FAILURE:
            return setTransferRequest(state, {
                status: STATUSES.ERROR,
            });
        
        case TRANSFER_ACCOUNT_DOWNLOAD_DOCUMENT_REQUEST:
            return setDownloadTransferDocument(state, { status: STATUSES.FETCHING });

        case TRANSFER_ACCOUNT_DOWNLOAD_DOCUMENT_SUCCESS:
            return setDownloadTransferDocument(state, { status: STATUSES.FETCHED });
    
        case TRANSFER_ACCOUNT_DOWNLOAD_DOCUMENT_FAILURE:
            return setDownloadTransferDocument(state, { status: STATUSES.ERROR });

        default:
            return state;
    }
}

export default bringAccount;
